<script setup lang="ts">
import { FormRow, FormSection } from '@it-tools/shell'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { isValidGb, LIMITS, type Transfer } from '../model/spec'
import NumberField from './NumberField.vue'

/** One section for the whole design: free allowances are counted per account, not per line. */
const props = defineProps<{ modelValue: Transfer }>()
const emit = defineEmits<{ 'update:modelValue': [Transfer] }>()

const { t, n } = useI18n()

const gbError = computed(() => t('form.gbInvalid', { max: n(LIMITS.gb) }))

function update(patch: Partial<Transfer>): void {
  emit('update:modelValue', { ...props.modelValue, ...patch })
}
</script>

<template>
  <FormSection :legend="t('kind.transfer')">
    <p class="transfer__hint">{{ t('form.transferHint') }}</p>
    <FormRow :label="t('form.outbound')" for-id="transfer-out">
      <NumberField
        id="transfer-out"
        :model-value="modelValue.outboundGb"
        :unit="t('form.gbPerMonth')"
        :valid="isValidGb"
        :error="gbError"
        @update:model-value="(outboundGb) => update({ outboundGb })"
      />
    </FormRow>
    <FormRow :label="t('form.inbound')" for-id="transfer-in">
      <NumberField
        id="transfer-in"
        :model-value="modelValue.inboundGb"
        :unit="`${t('form.gbPerMonth')} — ${t('form.inboundFree')}`"
        :valid="isValidGb"
        :error="gbError"
        @update:model-value="(inboundGb) => update({ inboundGb })"
      />
    </FormRow>
  </FormSection>
</template>

<style scoped>
.transfer__hint {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--color-text-muted);
}
</style>
